export class DettaglioProdotto {
  id: number;
  id_prodotto: number;
  nome: string;
  descrizione: string;
  id_immagine: number;
  immagine: string;
  file: string;
  modifica: boolean;
}

